var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"component_main px-6"},[_c('v-row',[_c('v-col',{attrs:{"cols":"8"}},[_c('CronogramaForm',{attrs:{"close":(formData)=>_vm.saveItem(formData),"dadoscronograma":_vm.dadoscronograma,"disableFields":!_vm.isNew,"isNew":_vm.isNew,"isComplementar":_vm.isComplementar}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }